export function defaultHeaders(): Headers {
  return new Headers({
    'content-type': 'application/json',
  });
}
